// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__30f-e","footer":"ChangeClinic_footer__2sFbO"};